import ApiService from "@/core/services/api.service";

export const PATH_DEPOSIT_REFUND = "deposit-refund";

export const GET_LIST_DEPOSIT_REFUND = "GET_LIST_DEPOSIT_REFUND";
export const GET_DEPOSIT_REFUND_STATUS_OPTIONS = "GET_DEPOSIT_REFUND_STATUS_OPTIONS";
export const GET_USER_MAIN_CLASSES_DEPOSIT_REFUND = "GET_USER_MAIN_CLASSES_DEPOSIT_REFUND";
export const CREATE_DEPOSIT_REFUND = "CREATE_DEPOSIT_REFUND";
export const REVIEW_DEPOSIT_REFUND = "REVIEW_DEPOSIT_REFUND";
export const GET_DEPOSIT_REFUND_DETAIL = "GET_DEPOSIT_REFUND_DETAIL";
export const PREVIEW_IMPORT_DEPOSIT_REFUND = "PREVIEW_IMPORT_DEPOSIT_REFUND";
export const IMPORT_DEPOSIT_REFUND = "IMPORT_DEPOSIT_REFUND";

const state = {};
const getters = {};

const actions = {
    [GET_LIST_DEPOSIT_REFUND](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.query(PATH_DEPOSIT_REFUND, payload)
                .then(({data}) => resolve(data))
                .catch(({response}) => reject(response));
        });
    },
    [GET_DEPOSIT_REFUND_STATUS_OPTIONS](context) {
        return new Promise((resolve, reject) => {
            ApiService.query(`${PATH_DEPOSIT_REFUND}/status-options`)
                .then(({data}) => resolve(data))
                .catch(({response}) => reject(response));
        });
    },
    [GET_USER_MAIN_CLASSES_DEPOSIT_REFUND](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.query(`${PATH_DEPOSIT_REFUND}/user-main-classes`, payload)
                .then(({data}) => resolve(data))
                .catch(({response}) => reject(response));
        });
    },
    [CREATE_DEPOSIT_REFUND](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(PATH_DEPOSIT_REFUND, payload)
                .then(({data}) => resolve(data))
                .catch(({response}) => reject(response));
        });
    },
    [REVIEW_DEPOSIT_REFUND](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`${PATH_DEPOSIT_REFUND}/${payload.deposit_refund_id}/review`, payload)
                .then(({data}) => resolve(data))
                .catch(({response}) => reject(response));
        });
    },
    [GET_DEPOSIT_REFUND_DETAIL](context, depositRefundId) {
        return new Promise((resolve, reject) => {
            ApiService.query(`${PATH_DEPOSIT_REFUND}/${depositRefundId}`)
                .then(({data}) => resolve(data))
                .catch(({response}) => reject(response));
        });
    },
    [PREVIEW_IMPORT_DEPOSIT_REFUND](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`${PATH_DEPOSIT_REFUND}/preview-import`, payload)
                .then(({data}) => resolve(data))
                .catch(({response}) => reject(response));
        });
    },
    [IMPORT_DEPOSIT_REFUND](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`${PATH_DEPOSIT_REFUND}/import`, payload)
                .then(({data}) => resolve(data))
                .catch(({response}) => reject(response));
        });
    },
};

const mutations = {};

export default {
    state,
    actions,
    mutations,
    getters,
};
